<template>
  <div class="main-content">
    <div class="main-title">用户编辑</div>
    <div class="from">
      <div class="row">
        <div class="title">用户名称</div>
        <input type="text" placeholder="请输入用户名称" v-model.trim="user.username">
      </div>
      <div class="row">
        <div class="title">用户密码</div>
        <input type="text" placeholder="请输入新的账户密码" v-model.trim="user.password">
      </div>
      <div class="row">
        <div class="title">真实姓名</div>
        <input type="text" placeholder="请输入新的账户密码" v-model.trim="user.realname">
      </div>
      <div class="row">
        <div class="title">手机号</div>
        <input type="text" placeholder="请输入新的账户密码" v-model.trim="user.phone">
      </div>
      <div class="row">
        <div class="title">E-mail</div>
        <input type="text" placeholder="请输入新的账户密码" v-model.trim="user.email">
      </div>
      <div class="row">
        <div class="title">性别</div>
        <el-radio-group v-model="user.gender">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <div class="title">用户地址</div>
        <el-select v-model="user.province" placeholder="请选择" @change="changeSelect('province')">
          <el-option
              v-for="item in arrProvince"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="user.city" placeholder="请选择" @change="changeSelect('city')">
          <el-option
              v-for="item in arrCity"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="user.dist" placeholder="请选择">
          <el-option
              v-for="item in arrDist"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <input class="address" type="text" placeholder="请输入详细地址" v-model.trim="user.address">
      </div>
      <div class="avatar-box">
        <label for="def_input">
          <img :src="user.avatar || require('@/assets/default_av.png')" alt=" ">
        </label>
        <input type="file" accept="image/*" hidden id="def_input" @change="getFile">
      </div>
      <div class="btn-box">
        <span class="btn-confirm" @click="editUser">确定</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getDistrict,editUser,getUserInfo} from "@/request/api";
import {Warning} from "@/plugins/warning";
import $ from "jquery";
import OSS from "ali-oss";
import md5 from "js-md5";

export default {
  name: "user_edit",
  components:{

  },
  data() {
    return {
      id:0,
      user:{},
      arrProvince:[],
      arrCity:[],
      arrDist:[],
      avatar:"",
    }
  },
  computed: {

  },
  created() {
    this.id = this.$route.query.id;
    this.getDistrict();
    if(this.id > 0){
      this.getUserInfo();
    }
  },
  mounted() {

  },
  methods: {
    editUser(){
      let password = '';
      if(this.user.password != ''){
        password = md5(this.user.password)
      }

      const requestData = {
        "id":this.id,
        "username":this.user.username,
        "password":password,
        "realname":this.user.realname,
        "phone":this.user.phone,
        "email":this.user.email,
        "gender":this.user.gender,
        "province":this.user.province,
        "city":this.user.city,
        "dist":this.user.dist,
        "address":this.user.address,
        "avatar":this.avatar,
      };

      editUser(requestData).then(()=>{
        Warning.success("操作成功");
      })
    },
    getUserInfo(){
      const requestData = {"id":this.id};
      getUserInfo(requestData).then((res)=>{
        this.user = res.data;
        this.user.password = "";
      })
    },
    getDistrict(){
      const requestData = {};
      getDistrict(requestData).then((res)=>{
        this.arrProvince = res.data
        this.arrProvince.forEach(item=>{
          if(item.id == this.user.province){
            this.arrCity = item.parent;
          }
        })
        this.arrCity.forEach(item=>{
          if(item.id == this.user.city){
            this.arrDist = item.parent;
          }
        })
      })
    },
    changeSelect(val){
      console.log(val)
      if(val == 'province'){
        this.arrProvince.forEach(item => {
          if (item.id == this.user.province) {
            this.arrCity = item.parent;
            this.user.city = item.parent[0].id;
          }
          this.arrCity.forEach(item => {
            if (item.id == this.user.city) {
              this.arrDist = item.parent;
              this.user.dist = item.parent[0].id;
            }
          })
        })
      }else if(val == 'city'){
        this.arrCity.forEach(item => {
          if (item.id == this.user.city) {
            this.arrDist = item.parent;
            this.user.dist = item.parent[0].id;
          }
        })
      }
    },
    getFile(e){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/file/upload',
        data:{
          suffix:fileExt[0],
          path:"avatar"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  console.log(data.result.data)
                  that.avatar = data.result.data.url
                  that.user.avatar = data.result.data.full_url
                }
              }
            });
          }else {
            Warning.open(data.msg);
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.main-content{
  width: 100%;
  border-radius: 30px;
  background: #fff;
  box-shadow: 0 15px 30px  rgba(0, 0, 0, .1);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-bottom: 45px;
  .main-title{
    font-size: 24px;
    font-weight: 600;
    color: #141414;
    margin-left: 30px;
    margin-top: 30px;
  }
  .from{
    width: 100%;
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
    border-collapse:separate;
    border-spacing:0px 30px;
    position: relative;
    .row{
      width: 100%;
      padding-top: 15px;
      padding-left: 15px;
      padding-right: 15px;
      .title{
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        font-family: PingFang HK-Regular, PingFang HK;
        font-weight: 400;
        color: #000000;
        margin-bottom: 15px;
      }
      & > input{
        height: 50px;
        min-width: 300px;
        border-radius: 25px 25px 25px 25px;
        opacity: 1;
        border: 2px solid #DDD1B4;
        padding-left: 15px;
        padding-right: 15px;
      }
      .el-select{
        margin-right: 15px;
      }
      .address{
        margin-top: 15px;
        min-width: 600px;
      }
    }
    .avatar-box{
      width: 200px;
      height: 200px;
      position: absolute;
      top:0;
      right: 30px;
      label {
        display: block;
        width: 100%;
        height: 100%;
        & > img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          cursor: pointer;
        }
      }
    }
    .btn-box{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 40px;
      padding-left: 15px;
      padding-right: 15px;
      .btn-confirm{
        display: block;
        width: 100%;
        line-height: 48px;
        font-size: 21px;
        font-weight: 300;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border-radius: 25px;
        background-color: #ba0704;
      }
    }
  }
}
</style>

<style>
.el-input__inner{
  border: 0;
}
</style>
